import React from "react";
import styles from "./DateSection.module.scss";

interface DateSectionProps {
	dateLabel: string;
	children: React.ReactNode;
}

export const DateSection: React.FC<DateSectionProps> = ({ dateLabel, children }) => {
	return (
		<div className={styles.container}>
			<div className={styles.dateHeader}>{dateLabel}</div>
			<div className={styles.items}>{children}</div>
		</div>
	);
};
